import { clarity } from "react-microsoft-clarity";
import TagManager from "react-gtm-module";
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCmlie5mLSMmOS2nUeANZf6240MRgzoVNY",
  authDomain: "line-up-dashboard.firebaseapp.com",
  projectId: "line-up-dashboard",
  storageBucket: "line-up-dashboard.appspot.com",
  messagingSenderId: "718021306305",
  appId: "1:718021306305:web:ea788827d6a5d0945cf140",
  measurementId: "G-KZJHR2ZKBV",
};

// Initialize Firebase App immediately so calls to getAnalytics() in components don't crash
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const analytics = getAnalytics(app);

// Disable Firebase tracking by default until consent is granted
setAnalyticsCollectionEnabled(analytics, false);

const isLocalhost = window.location.hostname === "localhost";

let initialized = false;

export const initAnalytics = (consentOptions = { analytics: false }) => {
  if (isLocalhost || initialized || !consentOptions.analytics) return;

  try {
    const clarityId = "vqwky21twe";
    clarity.init(clarityId);

    // Enable Firebase tracking now that consent is granted
    setAnalyticsCollectionEnabled(analytics, true);

    TagManager.initialize({ gtmId: "GTM-NBKFWFM" });

    initialized = true;
  } catch (error) {
    console.error("Error initializing analytics:", error);
  }
};
